// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tdBackGroundColor[data-v-3e306a3a] {\n  display: inline-block;\n  width: 30px;\n  height: 25px;\n  background: #26a69a;\n  border-radius: 10px;\n  color: #fff;\n  font-weight: 700;\n  padding-top:2px;\n}\n", ""]);
// Exports
module.exports = exports;
